interface UAInfo {
  isFastSouGou: RegExpMatchArray | null
  isMac: boolean
  isWin: boolean
  isMobile: boolean
  isAndroid: boolean
  isIOS: boolean
  isWeiXin: boolean
  isSafari: boolean
}

export default function getUA(): UAInfo {
  let ua = navigator.userAgent.toLowerCase()
  let uaObj: UAInfo = {
    isFastSouGou: null,
    isMac: false,
    isWin: false,
    isMobile: false,
    isAndroid: false,
    isIOS: false,
    isWeiXin: false,
    isSafari: false
  }

  uaObj.isFastSouGou = ua.match(/metasr/) && ua.match(/chrome/)
  uaObj.isMac =
    navigator.platform === 'Mac68K' ||
    navigator.platform === 'MacPPC' ||
    navigator.platform === 'Macintosh' ||
    navigator.platform === 'MacIntel'
  uaObj.isWin =
    navigator.platform === 'Win32' || navigator.platform === 'Windows'
  uaObj.isMobile = /iPhone|iPad|iPod|Android/i.test(ua)
  uaObj.isAndroid = /Android/i.test(ua)
  uaObj.isIOS = /iPhone|iPad|iPod/i.test(ua)
  uaObj.isWeiXin = /micromessenger/.test(ua)
  uaObj.isSafari = /safari/.test(ua) && !/chrome/.test(ua)

  return uaObj
}
